import Hero from './components/Hero';
import Services from './components/Services';
import BookingForm from './components/BookingForm';
import About from './components/About';
import Contact from './components/Contact';
import Reviews from './components/Reviews';
import Gallery from './components/Gallery';
import Footer from './components/Footer';
import Navbar from './components/Navbar';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-black relative">
      {/* Faint Logo Background */}
      <div 
        className="fixed inset-0 z-0 pointer-events-none"
        style={{
          backgroundImage: 'url(https://static.readdy.ai/image/74809ee30fca19c1acffe2fc12cb4256/b468e3fbe55eb15f4444c0166571278a.png)',
          backgroundSize: '400px 400px',
          backgroundPosition: 'center',
          backgroundRepeat: 'repeat',
          opacity: 0.03
        }}
      ></div>
      
      <div className="relative z-10">
        <Navbar />
        <Hero />
        <Services />
        <BookingForm />
        <About />
        <Contact />
        <Reviews />
        <Gallery />
        <Footer />
      </div>
    </div>
  );
}
